import styled from 'styled-components';

import colors from '@wecasa/common/src/utils/colors';

import Faq from '@wecasa/web-ui/src/components/faq/faq';
import StickyBottomWrapper from '@wecasa/web-ui/src/components/sticky-bottom-wrapper/sticky-bottom-wrapper';
import { minWidth } from '@wecasa/web-ui/src/styles/mixins';

const CLOSE_BUTTON_WRAPPER_HEIGHT = 69;

export const MembershipBackground = styled.div`
  background: ${colors.pink20};
  background-size: cover;
  padding: 50px 20px 40px;
  display: flex;
  flex-direction: column;

  ${minWidth.md`
    padding-left: 75px;
    padding-right: 75px;
  `}
`;

export const StickyContainer = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
`;

export const StyledStickyBottomWrapper = styled(StickyBottomWrapper)`
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  padding: 10px 15px;
`;

export const MembershipFaq = styled(Faq)`
  padding: 0 20px 30px;

  ${minWidth.md`
    padding: 0 75px 75px;
  `}
`;

export const Content = styled.div`
  position: relative;
  flex: 1;
  top: -30px;
  margin-bottom: ${-1.5 * CLOSE_BUTTON_WRAPPER_HEIGHT}px;

  ${minWidth.md`
    top: 0;
  `}
`;

export const StyledWhiteSpacerRoundedBorders = styled.div`
  background-color: ${colors.white100};
  margin-top: -30px;
  height: 30px;
  border-radius: 30px 30px 0 0;
`;

export const PriceCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 20px 40px;

  ${minWidth.md`
    padding: 0 75px 40px;
  `}
`;
